import prepaidCardImageQueries from '@apis/queries/prepaidCardImageQueries';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { GiftItemRow } from '@models/gift';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { useQuery } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    giftItem: GiftItemRow;
    giftCardImageId: string;
}

function CardInfo({ giftItem, giftCardImageId }:Props) {
    const { name, salePrice } = giftItem;
    const { setState } = useContext(GiftOrderContext);
    const { data } = useQuery(prepaidCardImageQueries.detail(giftCardImageId));
    const { t } = useTranslation('gift');
    const priceUnit = usePriceUnit();

    useEffect(() => {
        setState((prev) => ({ ...prev, cardName: name }));
    }, [name]);

    return (
        <Card spacing={4} align='center' fullWidth>
            <CardImage src={data?.imageUrl}
                width={84}
                height={60}
                alt={t('giftOrder.cardImageAlt')} />
            <Column spacing={1}>
                <Text size='title' fontWeight='bold' ellipsis>
                    {name}
                </Text>
                <Text size='body-short'>
                    {salePrice.toLocaleString()}{priceUnit}
                </Text>
            </Column>
        </Card>
    );
}

const Card = styled(Row)`
    padding: var(--spacing-4);
    background: ${colors.white};
`;

const CardImage = styled(Image)`
    flex-shrink: 0;
    border-radius: 8px;
    object-fit: cover;
`;

export default CardInfo;
